<div class="container-fluid py-4">
    <div class="row mb-4">
      <div class="col-12">
        <h3 class="section-title">Qualified Roles</h3>
      </div>
    </div>
  
    <!-- Filter Buttons -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="filter-buttons">
          <button 
            class="btn filter-btn"
            [class.active]="selectedIndustry === 'all'"
            (click)="filterByIndustry('all')">
            All Top Roles
          </button>
          <button 
            *ngFor="let industry of industries"
            class="btn filter-btn"
            [class.active]="selectedIndustry === industry"
            (click)="filterByIndustry(industry)">
            {{ formatIndustry(industry) }}
          </button>
        </div>
      </div>
    </div>
  
    <!-- Role Cards -->
    <div class="row">
      <div class="col-md-4 mb-4" *ngFor="let role of displayedRoles">
        <div class="role-card">
          <div class="role-card-header">
            <div class="industry-badge">{{ formatIndustry(role.industry) }}</div>
            <div class="match-score">
              <span class="score-number">{{ role.match_score }}%</span>
              <span class="score-label">Match Score</span>
            </div>
          </div>
          <div class="role-card-body">
            <h5 class="role-title">{{ formatRoleType(role.role_type) }}</h5>
            <div class="role-stats">
              <div class="stat-item">
                <mat-icon class="stat-icon">check_circle</mat-icon>
                <span>{{ role.requirements_met }}/{{ role.total_requirements }} Requirements Met</span>
              </div>
              <div class="stat-item">
                <mat-icon class="stat-icon">trending_up</mat-icon>
                <span>Exceed by {{ role.average_exceed }} points</span>
              </div>
            </div>
            <div class="requirements-section">
              <p class="requirements-title">Key Skills:</p>
              <div class="requirements-list">
                <div class="requirement-chip" *ngFor="let req of role.requirements_details">
                  <span class="trait-name">{{ formatRoleType(req.trait) }}</span>
                  <span class="trait-value">{{ req.user_value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Versatility Analytics -->
    <div class="row mt-4" *ngIf="versatilityData">
      <div class="col-12">
        <div class="versatility-card">
          <h4 class="versatility-title">Versatility Analytics</h4>
          <div class="row text-center">
            <div class="col-md-4">
              <div class="versatility-stat">
                <div class="stat-value">{{ versatilityData.industries_qualified }}</div>
                <div class="stat-label">Industries Qualified</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="versatility-stat">
                <div class="stat-value">{{ versatilityData.total_qualified_roles }}</div>
                <div class="stat-label">Total Qualified Roles</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="versatility-stat">
                <div class="stat-value">{{ versatilityData.versatility_score }}%</div>
                <div class="stat-label">Versatility Score</div>
                <div class="progress mt-2">
                  <div class="progress-bar bg-success" 
                       [style.width.%]="versatilityData.versatility_score">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>